// @flow
import { PermissionAction, Permission } from '../actions/permission'
import {
  SUCCESS_FETCH_PERMISSION,
  FAIL_FETCH_PERMISSION,
} from '../actions/permission'

export type PermissionState = {
  role: Permission
  latestPlan: boolean
  restricted: boolean
  allowed: boolean
  earlyAccess: boolean
  error: boolean
}

const init: PermissionState = {
  role: null,
  latestPlan: false,
  restricted: false,
  allowed: false,
  earlyAccess: false,
  error: false,
}

export default (state: PermissionState = init, action: PermissionAction) => {
  switch (action.type) {
    case SUCCESS_FETCH_PERMISSION:
      return {
        ...state,
        role: action.payload.role,
        latestPlan: action.payload.latestPlan,
        restricted: action.payload.restricted,
        allowed: action.payload.allowed,
        earlyAccess: action.payload.earlyAccess,
      }
    case FAIL_FETCH_PERMISSION:
      return { ...state, error: true }
  }
  return state
}
